"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavigationModeEnum;
(function (NavigationModeEnum) {
    NavigationModeEnum["SEARCH"] = "search";
    NavigationModeEnum["NAVIGATION"] = "navigation";
    NavigationModeEnum["GLOBAL"] = "global";
})(NavigationModeEnum = exports.NavigationModeEnum || (exports.NavigationModeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF2aWdhdGlvbi1tb2RlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvbmF2aWdhdGlvbi1tb2RlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLGtCQUlYO0FBSkQsV0FBWSxrQkFBa0I7SUFDNUIsdUNBQWlCLENBQUE7SUFDakIsK0NBQXlCLENBQUE7SUFDekIsdUNBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUpXLGtCQUFrQixHQUFsQiwwQkFBa0IsS0FBbEIsMEJBQWtCLFFBSTdCIn0=